import { render, staticRenderFns } from "./AnnualSavingsChart.vue?vue&type=template&id=4891cbc2"
import script from "./AnnualSavingsChart.vue?vue&type=script&lang=js"
export * from "./AnnualSavingsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports